import { useRef, useState } from 'react';
import logo from './logo.png';
import './App.css';
// import Schedule from './schedule';
import { useNavigate } from 'react-router-dom';
// import redbird1 from './images/redbird1.jpeg';




function NavMenu() {
 const navigate = useNavigate();

function globalNavigation(destination: string) {
  // const navigate = useNavigate();
  navigate(destination);
}

function openExternalLink(url: string) {
  window.open(url, '_blank');
}


const goToSchedulePage = () => {
    navigate('/schedule');
  };


  function navButtons(mobileActive:boolean){
    return(
      <>
      <button onClick={() =>{globalNavigation(""); toggleMobileNav(mobileActive)}}>Learn More</button>
      <button onClick={() => {globalNavigation("contact"); toggleMobileNav(mobileActive)}}>Contact</button>
      <button style={{color:"white",backgroundColor:"red"}}className="focusItem" onClick={() => {globalNavigation("earlyAccess"); toggleMobileNav(mobileActive)}}>Early Access Form</button>

            {/* <button onClick={() => {globalNavigation("simulator"); toggleMobileNav(mobileActive)}}>Simulator</button> */}
            {/* <button onClick={() => {globalNavigation("schedule"); toggleMobileNav(mobileActive)}}>Daily Schedule</button>
            <button onClick={() => {openExternalLink("https://calendly.com/vfrnr");toggleMobileNav(mobileActive)}}>Reserve Time Now!</button> */}
            </>
    );
  }

  const [mobileNavOpen, setMobileNavOpen] = useState(false);
  const mobileNavModalRef = useRef<HTMLDivElement>(null);

  function toggleMobileNav(mobileActive?:boolean) {
    if(mobileActive){
    if(mobileNavModalRef.current){
      if(mobileNavOpen){
        mobileNavModalRef.current.style.display = "none";
        setMobileNavOpen(false);
      } else {
        mobileNavModalRef.current.style.display = "flex";
        setMobileNavOpen(true);
      }
    }
  }
  }
  
  
  return (
    <div className="appHeader">
          <img src={logo}  onClick={() => globalNavigation("")} alt="logo" />
          <div className="navMenu">
            {navButtons(false)}
            {/* <button onClick={() => globalNavigation("")}>About</button>
            <button onClick={() => globalNavigation("simulator")}>Simulator</button>
            <button onClick={() => globalNavigation("schedule")}>Daily Schedule</button>
            <button onClick={() => globalNavigation("contact")}>Contact</button>
            <button onClick={() => openExternalLink("https://calendly.com/vfrnr")}>Reserve Time Now!</button> */}
            
          </div>


          <div className="mobileNavMenu">
            <button onClick={()=> toggleMobileNav()}className="mobileNavMenuButton">☰</button>
            <div ref={mobileNavModalRef}className="mobileNavModal">
              {navButtons(true)}
            </div>
          </div>
        </div>
  );
}

export default NavMenu;
